import React from "react";
import { FaTimes } from "react-icons/fa";

const AspectRatioModal = ({
  isOpen,
  onClose,
  aspectRatio,
  setAspectRatio,
  allowedAspectRatiosSet,
  isPreview = false,
  className = "",
  AspectIcon
}) => {
  if (!isOpen && !isPreview) return null;
  const options = [
    { ui: '16:9', val: '16:9' },
    { ui: '9:16', val: '9:16' },
    { ui: '1:1', val: '1:1' },
    { ui: '4:3', val: '4:3' },
    { ui: '3:4', val: '3:4' },
    { ui: '4:5', val: '4:5' },
    { ui: '5:4', val: '5:4' },
    { ui: '3:2', val: '3:2' },
    { ui: '2:3', val: '2:3' },
    { ui: '21:9', val: '21:9' }
  ].filter(r => allowedAspectRatiosSet.has(r.val));

  const Panel = (
    <div className="glass-effect rounded-2xl border border-white/10 bg-[#111111]/95 backdrop-blur-2xl p-4 w-72 sm:w-80">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-4 h-4"><AspectIcon ratio={aspectRatio} className="w-4 h-4" /></span>
        <h3 className="text-xs font-medium text-white">Aspect ratio</h3>
        {!isPreview && (
          <button type="button" className="ml-auto text-gray-300 hover:text-white" onClick={onClose}>
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map(r => (
          <button
            key={r.ui}
            type="button"
            className={`px-2 py-1 rounded-full border text-[11px] ${aspectRatio === r.val ? 'bg-white/10 text-white border-white/20' : 'text-gray-300 border-gray-600/40'}`}
            onClick={() => { setAspectRatio(r.val); if (!isPreview) onClose(); }}
            title={r.ui}
          >
            <span className="inline-flex items-center gap-1">
              <AspectIcon ratio={r.val} className="w-3 h-3" />
              <span>{r.ui}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );

  if (isPreview) return <div className={`absolute z-50 pointer-events-auto ${className}`}>{Panel}</div>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      {Panel}
    </div>
  );
};

export default AspectRatioModal; 